import { message } from 'antd';

/**
 * Pulls the most specific error message from an axios/fetch error.
 * Falls back to `fallback` if no real message is found.
 */
export function extractErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    fallback
  );
}

/**
 * Displays a toast using antd message.
 * type: 'success' | 'error' | 'warning' | 'info'
 */
export function showToast(text, type = 'success') {
  const fn = message[type] || message.info;
  fn({ content: text, duration: 4 });
}

/**
 * One-liner: extracts error message and shows it as a toast.
 */
export function showError(err, fallback) {
  showToast(extractErrorMessage(err, fallback), 'error');
}

/**
 * React hook that returns a showNotify(text, type) function backed by antd toast.
 * Drop-in replacement for the local showNotify state pattern used in several screens.
 */
export function useAppNotify() {
  const showNotify = (text, type = 'success') => showToast(text, type);
  return { showNotify };
}
